<template>
  <div id="index_box">
    <el-table :data="meijieList" style="width: 100%">
      <el-table-column prop="adminName" label="媒介" />
      <el-table-column prop="currentMonthTotal" label="本月" />
      <el-table-column prop="lastMonthTotal" label="上月" />
      <el-table-column prop="historyTotal" label="历史统计" />
    </el-table>
    <el-pagination
      :current-page="pageInfo.currentPage"
      :page-sizes="pageInfo.pageSizeList"
      :page-size="pageInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalPage"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>
<script>
export default {
  props: ['meijieList', 'totalPage'],
  data() {
    return {
      pageInfo: {
        limit: 30,
        allCount: 0,
        currentPage: 1,
        currentPageCount: 0,
        pageSizeList: [30, 50, 100, 150, 200, 300],
        showEdit: false // 是否显示快捷编辑代码框
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.pageInfo.limit = val
      this.pageInfo.currentPage = 1
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val
      this.fetchData()
    }

  }
}
</script>
